/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// apis
import { deleteCardPurchaseItems, getCardPurchaseSummariesDetail } from "../../../../apis/finances/cards";
// components
import Modal, { ModalHeader } from "../../../../components/Modal";
import { ControlTable } from "../../../../components/Table";
// utils
import { isEmpty } from "lodash";
import { viewLoading } from "../../../../utils/loading";
import Button from "../../../../components/Button";
import { transformComNum } from "../../../../utils/validator/comNum";
import { dateToViewFormat } from "../../../../utils/date";
import { PAYMENT_TYPE } from "../../../../constants/EXPENSE";
import Profile from "../../../../components/Profile";
import systemAlert from "../../../../utils/systemAlert";
import Comment from "../../../../components/Comment";
import DataComponent from "../../../../components/DataComponent";
import { TASK_STATUS_LIST } from "../../../../constants/TASK";
import PurchaseDetail from "./PurchaseDetail";

const Purchase = ({ open, setOpen, data, setData, permission, submit }) => {
  const [fields] = useState([
    { title: "거래일자", key: "useTime", type: "date" },
    { title: "결제금액", key: "useAmt", type: "comma" },
    { title: "거래타입", key: "useDiv" },
    { title: "상태", key: "apprSt" },
    { title: "가맹점", key: "useStore" },
    { title: "업종", key: "storeType" },
    { title: "사업자번호", key: "storeBizNo" },
    //{ title: "가맹점 전화번호", key: "storeTel" },
  ]);
  const [list, setList] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false)
  const [detailData, setDetailData] = useState({})
  const [resultRow, setResultRow] = useState({});
  // 연관 은행 입출금 내역 필드
  const [bankTransFields] = useState([
    { title: "거래일자", key: "tradeTime", type: "date" },
    { title: "계좌정보", key: "bankName" },
    { title: "입금액", key: "inAmt", type: 'comma' },
    { title: "출금액", key: "outAmt", type: 'comma' },
    { title: "적요", key: "traderName" },
    { title: "거래처", key: "clients[0].name" },
  ]);
  const [bankTransList, setBankTransList] = useState([]);
  // 연관 거래명세서 내역 필드
  const [invoiceFields] = useState([
    { title: "일자", key: "writeDate" },
    { title: "상호", key: "supCorpName" },
    { title: "대표자명", key: "supRepName" },
    {
      title: "사업자번호",
      key: "supBizNo",
      onValue: (value) => {
        return transformComNum(value)
      }
    },
    {
      title: "공급가액",
      key: "supplyAmt",
      type: 'comma'
    },
    {
      title: "세액",
      key: "taxAmt",
      type: 'comma'
    },
    {
      title: "합계금액",
      key: "totalAmt",
      type: 'comma'
    },
  ]);
  const [invoiceList, setInvoiceList] = useState([])
  // 연관 지출청구 내역
  const [expenseFields] = useState([
    {
      title: "작성일시",
      key: "createdTime",
      onValue: (value) => {
        return (
          <div className="list-date-wrap">
            <p className="list-date">{dateToViewFormat(value)}</p>
            <p className="list-date-time">{dateToViewFormat(value, "HH:mm")}</p>
          </div>
        );
      },
    },
    {
      title: "작성자",
      key: "reqEmployeeIdx",
      onValue: (value) => {
        return (
          <Profile
            employeeIdx={value} />
        )
      },
    },
    {
      title: "타입",
      key: "payType",
      onTranslator: {
        list: PAYMENT_TYPE,
      },
    },
    { title: "합계금액", key: "useAmt", type: "comma" },
    { title: "비용항목", key: "expenseOptionName" },
    {
      title: "결재상태",
      key: "apprStatus",
      onValue: (value) => {
        const target = TASK_STATUS_LIST.find(
          (vacation) => vacation.status === value
        );
        return (
          <DataComponent
            field={{
              type: "badge",
              color: target.color,
              label: target.label,
            }}
          />
        );
      },
    },
  ]);
  const [expenseList, setExpenseList] = useState([])

  const cancel = () => {
    setOpen(false);
    setData({});
  };

  useEffect(() => {
    if (!isEmpty(data)) {
      _submit();
    }
  }, [data]);

  const _submit = () => {
    if (!isEmpty(data)) {
      const { useDate, cardIdx } = data;
      const body = {
        useDate,
        cardIdx,
      };
      viewLoading(true);
      getCardPurchaseSummariesDetail(body)
        .then((res) => {
          const {
            bankTransList,
            cardPurchaseList,
            cardPurchaseSummary,
            invoiceList,
            expenseList,
          } = res.data;
          setList(cardPurchaseList);
          setBankTransList(bankTransList);
          setInvoiceList(invoiceList)
          setExpenseList(expenseList)
          setResultRow({
            useTime: "합계",
            useAmt: cardPurchaseSummary.useAmt,
            useDiv: " ",
            useStore: " ",
            storeType: " ",
            storeBizNo: " ",
            storeTel: " ",
          });
        })
        .catch(() => { })
        .finally(() => viewLoading(false));
    }
  };

  const bankTableRowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (rowData) => {
          const { cardUseItemIdx } = rowData
          systemAlert('해당 연관 데이터를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true)
                  deleteCardPurchaseItems('bank_trans', cardUseItemIdx).then(() => _submit()).catch(() => { }).finally(() => viewLoading(false))
                }
              }
            ]
          })
        },
      },
    ],
  };

  const invoiceTableRowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (rowData) => {
          const { cardUseItemIdx } = rowData
          systemAlert('해당 연관 데이터를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true)
                  deleteCardPurchaseItems('invoice', cardUseItemIdx).then(() => _submit()).catch(() => { }).finally(() => viewLoading(false))
                }
              }
            ]
          })
        },
      },
    ],
  };

  const expenseTableRowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (rowData) => {
          const { cardUseItemIdx } = rowData
          systemAlert('해당 연관 데이터를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true)
                  deleteCardPurchaseItems('expense', cardUseItemIdx).then(() => _submit()).catch(() => { }).finally(() => viewLoading(false))
                }
              }
            ]
          })
        },
      },
    ],
  };

  const handleRowClick = (data, e) => {
    if (e.target.tagName !== 'TR' && e.target.tagName !== 'TD') return
    setDetailData(data)
    setDetailOpen(true)
  }

  return (
    <>
      {!detailOpen && (
        <Modal isOpen={open} close={cancel}>
          <div className="card-summaries-detail">
            <ModalHeader>신용카드 매입 상세화면</ModalHeader>
            <ControlTable fields={fields} list={list} resultRow={resultRow} onSelect={handleRowClick} />
            <div className="related-container">
              <div className="related-body">
                <label className="related-header-title">
                  연관 은행 입출금 내역
                </label>
                <ControlTable fields={bankTransFields} list={bankTransList} rowBtn={bankTableRowBtnConfig} />
              </div>
              <div className="related-body">
                <label className="related-header-title">
                  연관 거래명세서 내역
                </label>
                <ControlTable fields={invoiceFields} list={invoiceList} rowBtn={invoiceTableRowBtnConfig} />
              </div>
              <div className="related-body">
                <label className="related-header-title">
                  연관 지출청구 내역
                </label>
                <ControlTable fields={expenseFields} list={expenseList} rowBtn={expenseTableRowBtnConfig} />
              </div>
            </div>
            <div className="margin-top-24">
              <Comment
                postIdx={data.idx}
                postType="card_purchase_summary"
                submit={submit}
              />
            </div>
            <div className="margin-top-20">
              <Button className="close-button" label="닫기" onClick={cancel} />
            </div>
          </div>
        </Modal>
      )}
      {detailOpen && (
        <PurchaseDetail
          open={detailOpen}
          setOpen={setDetailOpen}
          data={detailData}
          permission={permission}
        />
      )}
    </>
  );
};

export default Purchase;
